import * as _ from 'underscore';
import { View } from './view';
import { Table } from '..';
import { ListViewOptions } from '../../interfaces/options';
import { DataSource } from '../data';
import { DefaultListViewOptions } from '../../const/defaultOptions';
import { loading } from '../../decorators';

export abstract class ListView<T> extends View {
	public table: Table<T>;
	abstract new(...params: any[]): T | void;
	abstract edit(item: T): void;
	abstract delete(item: T): Promise<any>;
	constructor(options: ListViewOptions<T>) {
		_.defaults(options.view, DefaultListViewOptions);
		super(options.view);
		if (!(options.table.dataSource instanceof DataSource)) {
			if (!_.isFunction(options.table.dataSource.new)) {
				options.table.dataSource.new = (...params: any[]) => {
					return this.new.apply(this, params);
				};
			}
			if (!_.isFunction(options.table.edit)) {
				options.table.edit = (item: T) => {
					this.edit(item);
				};
			}
			if (!_.isFunction(options.table.dataSource.delete)) {
				options.table.dataSource.delete = (item: T) => {
					return this._delete(item);
				};
			}
			if (!_.isFunction(options.table.dataSource.loading)) {
				options.table.dataSource.loading = (loading: boolean) => {
					this.loading(loading);
				};
			}
		}
		this.table = new Table(options.table);
		this.ViewActivated.subscribe(() => {
			this.loading(true);
			this.reload()
				.then(() => {}, () => {})
				.then(() => this.loading(false));
		});
		this.ViewDeactivated.subscribe(() => {
			this.table.cancel(true);
		});
	}
	public reload(): Promise<DataSource<T>> {
		return this.table.reload();
	}
	@loading
	private _delete(item: T): Promise<any> {
		return this.delete(item);
	}
}
